import { takeEvery } from "redux-saga/effects";
import { fetchDataSagaGOS } from "../store/filterData/saga";
import { StrapiActionTypes } from "../types/strapiGOS";
import {
  addDataGOSSaga,
  deleteDataGOSSaga,
  updateDataGOSSaga,
} from "../store/addForms/saga";
import { FileUploadActionTypes } from "../store/fileUploads/actions";
import {
  uploadFileSaga,
  fetchFilesSaga,
  deleteFileSaga,
  downloadFileSaga,
} from "../store/fileUploads/saga";
import { fetchSettingsRequest } from "src/pages/DashboardPage/gos/store/settings/settings";
import { handleFetchSettingsSaga } from "src/pages/DashboardPage/gos/store/settings/saga";
import { fetchHelpInfoRequest } from "src/pages/DashboardPage/gos/store/help/help";
import { handleFetchHelpInfoSaga } from "src/pages/DashboardPage/gos/store/help/saga";

export function* gosWatcherStrapi() {
  yield takeEvery(StrapiActionTypes.FETCH_REQUEST_GOS, fetchDataSagaGOS);
  yield takeEvery(StrapiActionTypes.ADD_REQUEST_GOS, addDataGOSSaga);
  yield takeEvery(StrapiActionTypes.UPDATE_REQUEST_GOS, updateDataGOSSaga);
  yield takeEvery(StrapiActionTypes.DELETE_REQUEST_GOS, deleteDataGOSSaga);
  yield takeEvery(fetchSettingsRequest.type, handleFetchSettingsSaga);
  yield takeEvery(fetchHelpInfoRequest.type, handleFetchHelpInfoSaga);

  yield takeEvery(FileUploadActionTypes.UPLOAD_FILE_REQUEST, uploadFileSaga);
  yield takeEvery(FileUploadActionTypes.FETCH_FILES_REQUEST, fetchFilesSaga);
  yield takeEvery(FileUploadActionTypes.DELETE_FILE_REQUEST, deleteFileSaga);
  yield takeEvery(
    FileUploadActionTypes.DOWNLOAD_FILE_REQUEST,
    downloadFileSaga,
  );
}
